'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { isMapViewAtom } from '@/features/listing/atoms/is-map-view-atom';
import { type ListingType } from '@/features/listing/types/listing-types';
import { type Place, type PlaceBoundingBox } from '@/features/place/types/place-types';
import calculateCenterFromBbox from '@/features/place/utils/calculate-center-from-bbox';
import styles from './listings-map.module.scss';
import { useSearchParams } from "next/navigation";
const mapLoader = () => <p>A map is loading</p>;
const Map = dynamic(() => import('@/features/listing/components/listings-map/map/map-render'), {
  loading: mapLoader,
  ssr: false
});
interface ListingsMapProps {
  listingType: ListingType;
  currentPlace: Place;
  mapBbox?: PlaceBoundingBox;
}
export default function ListingsMap(props) {
  const $ = _c(19);
  const {
    currentPlace,
    mapBbox,
    listingType
  } = props;
  const isMapView = useAtomValue(isMapViewAtom);
  const [isDesktopViewport, setIsDesktopViewport] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const mediaQuery = globalThis.window.matchMedia("(min-width: 1024px)");
      const updateViewportState = () => {
        setIsDesktopViewport(mediaQuery.matches);
      };
      updateViewportState();
      mediaQuery.addEventListener("change", updateViewportState);
      return () => {
        mediaQuery.removeEventListener("change", updateViewportState);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = mapBbox ?? currentPlace.bbox;
  let t3;
  if ($[2] !== t2) {
    t3 = calculateCenterFromBbox(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    latitude,
    longitude
  } = t3;
  const searchParams = useSearchParams();
  let t4;
  if ($[4] !== searchParams) {
    t4 = new URLSearchParams(searchParams);
    $[4] = searchParams;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const urlSearchParams = t4;
  const shouldRenderMap = isDesktopViewport || isMapView;
  const t5 = isMapView && styles.map__isActive;
  let t6;
  if ($[6] !== t5) {
    t6 = cx(styles.map, t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== currentPlace || $[9] !== latitude || $[10] !== listingType || $[11] !== longitude || $[12] !== mapBbox || $[13] !== shouldRenderMap || $[14] !== urlSearchParams) {
    t7 = shouldRenderMap && <Map listingType={listingType} searchParams={urlSearchParams} currentPlace={currentPlace} mapBbox={mapBbox ?? currentPlace.bbox} coordinates={{
      lat: latitude,
      lng: longitude
    }} />;
    $[8] = currentPlace;
    $[9] = latitude;
    $[10] = listingType;
    $[11] = longitude;
    $[12] = mapBbox;
    $[13] = shouldRenderMap;
    $[14] = urlSearchParams;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}